import rightArrow from 'common/assets/image/saasAppCreative/icons/right-arrow.svg';
import Heading from 'common/components/Heading';
import Link from 'common/components/Link';
import Text from 'common/components/Text';
import Container from 'common/components/UI/Container';
import {graphql, useStaticQuery} from 'gatsby';
import React from 'react';
import Section, {Content, FigureGroup, Grid} from './analytics.style';
import {Features} from '../../WebAppCreative/AnalyticsTool/analytics.style';
import {check} from 'react-icons-kit/feather/check';
import {Icon} from 'react-icons-kit';
import LazyLoad from 'react-lazyload';

const AnalyticsTool = () => {
  // const data = useStaticQuery(graphql`
  //   query {
  //     graph1: file(relativePath: { eq: "image/saasAppCreative/graph1.png" }) {
  //       childImageSharp {
  //         gatsbyImageData(
  //           width: 552
  //           placeholder: BLURRED
  //           formats: [AUTO, WEBP, AVIF]
  //         )
  //       }
  //     }
  //     graph2: file(relativePath: { eq: "image/saasAppCreative/graph2.png" }) {
  //       childImageSharp {
  //         gatsbyImageData(
  //           width: 360
  //           placeholder: BLURRED
  //           formats: [AUTO, WEBP, AVIF]
  //         )
  //       }
  //     }
  //   }
  // `);
  return (
    <Section>
      <Container width="1360px">
        <Grid>
          <FigureGroup>
            <LazyLoad height={500}>
            <video autoPlay loop muted playsinline controls style={{width: "100%"}}　title="Autolikesについて">
              <source src="/wp-content/uploads/autolikes_demo.mp4" />
            </video>
            </LazyLoad>
          </FigureGroup>
          <Content>
            <Text className="subtitle" content="About Autolikes" />
            <Heading content="Autolikesについて" />
            <Text
              className="description"
              content={<p>Autolikesはお客様に代わって、毎日いいねやフォローを自動で行うAIボットアプリです。SNSの運用時間を節約し効率的にフォロワーを増やすことができます。</p>}
            />
            <Features>
              {/*{analyticsTool.features.map((feat, i) => (*/}
                <li key={1}>
                  <Icon icon={check} size={22} />
                  今なら初月無料でご利用できます！
                </li><li key={2}>
                  <Icon icon={check} size={22} />
                  WEB広告の1/30で効果を実感！
                </li>
                <li key={3}>
                  <Icon icon={check} size={22} />
                  ユーザーの86%が継続利用！
                </li>
                <li key={4}>
                  <Icon icon={check} size={22} />
                  業界最安値！
                </li>
              {/*))}*/}
            </Features>
            <Link href="/instagram" className="explore">
              詳細を見る
              <img src={rightArrow} alt="right arrow icon" />
            </Link>
          </Content>
        </Grid>
      </Container>
    </Section>
  );
};

export default AnalyticsTool;
